// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { NamedExoticComponent } from "react";

export const constants = {
    footer: {
        offsetTop: 60,
    },
    cartLine: {
        breakpoints: {
            md: 1200,
            xs: "xs",
        },
    },
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    productGridView: {
        desktop: {
            width: 308,
            height: 308,
        },
        tablet: {
            width: 346,
            height: 230,
        },
        mobile: {
            width: 328,
            height: 280,
        },
    },
    onePageCheckout: {
        tablet: 1242,
    },
};

export const XNGAGE_CUSTOM_WIDGET = "Xngage Custom" as any;
export const EMPTY_VALUE = "---";
export const DivWrapper = `div[class^="Wrapper"]`;

interface AddToCartStatusInfoInterface {
    status: string;
    label: string;
    icon: NamedExoticComponent<{}> | string;
}
interface AddToCartStatusInterface {
    default: AddToCartStatusInfoInterface;
    loading: AddToCartStatusInfoInterface;
    success: AddToCartStatusInfoInterface;
}

export const addToCartStatus: AddToCartStatusInterface = {
    default: {
        status: "default",
        label: "Add to Cart",
        icon: "",
    },
    loading: {
        status: "loading",
        label: "",
        icon: "",
    },
    success: {
        status: "success",
        label: "Added",
        icon: "",
    },
};

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
};

export const checkoutPages = ["OnePageCheckoutPage", "CheckoutShippingPage", "CheckoutReviewAndSubmitPage"];

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export enum USER_ROLES {
    ADMIN = "Administrator",
    BUYER1 = "Buyer1",
    BUYER2 = "Buyer2",
    BUYER3 = "Buyer3",
    FINANCE = "Finance",
    REQUISITIONER = "Requisitioner",
}

export const placeHolders = {
    email: "Email@Address.com",
    phone: "( ___ ) ___ - ____",
};

export const PRODUCT_CAROUSEL_SLIDES_PER_SCREEN_SIZE = {
    mobile: 1,
    tablet: 1.8,
    desktop: 3.8,
    wide: 4.8,
};

export const productOptionsTablePageSize = 8;

export const FORM_IDS = {
    BASIC_INFO: "basic-info-formId",
    BILLING_ADDRESS: "billing-address-formId",
    SHIPPING_ADDRESS: "shipping-address-formId",
};
